import React, { useCallback, useRef} from 'react';
import {Select} from 'antd';
import { WidgetProps } from '@rjsf/utils';


interface Option {
  label: string; 
  value: string;
}

const SelectWithSearch= (props: WidgetProps) => {
  const {
      value,
      onChange,
      disabled,
      readonly,
      schema
  } = props;

  const selectRef = useRef<HTMLDivElement>(null);

 
  // Widget should be disabled if explicitly disabled, readonly, or in detail mode
  const isDisabled = disabled || readonly;


  const handleChange = useCallback(
      (value: string) => {
        onChange(value);
      },
      [onChange]
    );

  return (
    <div className='' ref={selectRef}>
    <Select
      value={value || undefined}
      disabled={isDisabled}
      showSearch
      placeholder="Zoek..."
      filterOption={(input, option: Option | undefined) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      onChange={handleChange}
      options={schema.enum.map((item: string) => ({ label: item, value: item }))}
    />
    </div>
  );
};

export default SelectWithSearch;